// extracted by mini-css-extract-plugin
export default {"Success":"Success___qOmtP","resourceInfo":"resourceInfo___ZsKBg","buttons":"buttons___uHgYv"};